import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DistributorsComponent } from './distributors/distributors.component';
import { RetailersComponent } from './retailers/retailers.component';
import { StaffComponent } from './staff/staff.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { PurchaseLimitsComponent } from './purchase-limits/purchase-limits.component';
import { SettingsComponent } from './settings/settings.component';
import { authGuard } from './auth.guard';

export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'dashboard' },
	{ path: 'login', component: LoginComponent },
	{ path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
	{ path: 'distributors', component: DistributorsComponent, canActivate: [authGuard], data: { roles: ['admin', 'super_admin', 'staff'] } },
	{ path: 'retailers', component: RetailersComponent, canActivate: [authGuard], data: { roles: ['admin', 'super_admin', 'distributor', 'staff'] } },
	{ path: 'staff', component: StaffComponent, canActivate: [authGuard], data: { roles: ['admin', 'super_admin'] } },
	{ path: 'invoices', component: InvoicesComponent, canActivate: [authGuard], data: { roles: ['admin', 'super_admin', 'distributor'] } },
	{ path: 'transactions', component: TransactionsComponent, canActivate: [authGuard], data: { roles: ['admin', 'super_admin'] } },
	{ path: 'purchase-limits', component: PurchaseLimitsComponent, canActivate: [authGuard], data: { roles: ['admin', 'super_admin'] } },
	{ path: 'settings', component: SettingsComponent, canActivate: [authGuard] },
	{ path: '**', redirectTo: 'login' }
];
